<template>
  <div class="content">
    <section class="box fff">
      <div class="section-main">
        <div class="lr">
          <div class="l">
            <img :src="$common.getResourceUrl('xiaobaijiaoyu.jpg')" />
          </div>
          <div class="r">
            <div class="title">公司简介</div>
            <div class="content">
              {{ $domain.name }}是一款为职场小白打造的线上学习平台，隶属于
              {{
                $domain.company
              }}，创建于2020年2月，总部位于山东济南，是一家新型在线职业教育平台，专注小白在线职业教育、在线职业提升、提供职业技能类课程。
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: '',
  // Swiper,
  components: {},
  props: {},

  data() {
    return {}
  },
  computed: {
    scrollTop() {
      return this.$root.$children[0].scrollTop
    },
    pageBarHeight() {
      return this.$refs.pageBar ? parseInt(this.$refs.pageBar.barHeight) : 0
    },
    pageBarBg() {
      return this.scrollTop > this.pageBarHeight ? '#fff' : ''
    },
    pageBarLogoBg() {
      return this.scrollTop > this.pageBarHeight ? '' : '#fff'
    },
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
section {
  width: 100%;
  min-width: 1200px;
}
.fff {
  background-color: #fff;
}

.section-main {
  width: 1200px;
  min-height: calc(100vh - 225px);
  margin: 0 auto;
  padding: 80px 20px;
}

.lr {
  display: flex;

  .l {
    width: 300px;
    margin-right: 40px;
    img {
      width: 100%;
    }
  }

  .r {
    flex: 1;
    .title {
      font-size: 28px;
      margin-bottom: 30px;
    }
    .content {
      line-height: 1.6;
    }
  }
}
</style>
